import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    q: "How do I add a widget to my site?",
    a: "It's as simple as copying a single line of code. Once you customize your widget in our editor, we provide an embed code that you can paste directly into your website's HTML."
  },
  {
    q: "Is the data updated in real-time?",
    a: "Yes. Our football data feeds are updated instantly as events happen on the pitch, ensuring your visitors always see the most accurate information."
  },
  {
    q: "Can I customize the look to match my site?",
    a: "Absolutely. You can choose between light and dark modes and adjust colors to ensure the widgets feel like a native part of your design."
  },
  {
    q: "Do I need to be a developer to use this?",
    a: "Not at all. Scorewidget is designed for everyone. If you can copy and paste text, you can use our platform to add professional football data to your site."
  }
];

const FAQItem = ({ faq, isOpen, onClick }) => {
  return (
    <div className="border-b border-slate-200 last:border-0">
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between py-6 text-left focus:outline-none group"
      >
        <span className={`text-lg font-semibold transition-colors ${isOpen ? 'text-brand-600' : 'text-slate-900 group-hover:text-brand-600'}`}>
          {faq.q}
        </span>
        <div className={`flex-shrink-0 ml-4 p-1 rounded-full transition-colors ${isOpen ? 'bg-brand-50 text-brand-600' : 'bg-slate-100 text-slate-400 group-hover:bg-slate-200'}`}>
          <SafeIcon icon={isOpen ? FiMinus : FiPlus} className="w-5 h-5" />
        </div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-slate-600 leading-relaxed">
              {faq.a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-24 bg-white border-t border-slate-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">Common Questions</h2>
          <p className="text-slate-600">Everything you need to know about using Scorewidget.</p>
        </div>
        
        <div className="bg-slate-50/50 rounded-2xl border border-slate-200 px-6 md:px-8">
          {faqs.map((faq, index) => (
            <FAQItem 
              key={index} 
              faq={faq} 
              isOpen={openIndex === index} 
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;